import { INVALID_USERNAME_FIELD_TEXT, REQUIRED_FIELD_TEXT } from '../constants/app';

export const isValidSlug = (slug: string): boolean => {
  const slugPattern = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
  return slugPattern.test(slug);
};

export const preventMinus = (event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
  if (event.code === 'Minus') {
    event.preventDefault();
  }
};

export const preventDotAndComma = (event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
  if (event.key === '.' || event.key === ',') {
    event.preventDefault();
  }
};

export function isValidUsername(username: string): boolean {
  const pattern = /^[A-Za-z0-9._\-!@#$%^&*()+=\[\]{}|:;"'<>,?/\\~`]+$/;
  return pattern.test(username);
}

export function invalidUserNameError(touched: boolean, username: string, isValid: boolean) {
  if (touched) {
    if (!username) return REQUIRED_FIELD_TEXT;
    if (!isValid) return INVALID_USERNAME_FIELD_TEXT;
  }
  return undefined;
}
